import { setAppSpinning, showNotification } from 'app/appSlice'
import CancelInvoiceModal from 'general/components/Modal/CancelInvoiceModal'
// import FindInvoiceModal from 'general/components/Modal/FindInvoiceModal'
import { List, Space, Tooltip } from 'antd'
import invoiceApi from 'api/invoiceApi'
import dayjs from 'dayjs'
import {
  setClearRows,
  setModalsState,
  setSelectedInvoices,
} from 'features/Invoice/invoiceSlice'
import ModalConvertPaper from 'features/Search/components/ModalConvertPaper'
import AppDnD from 'general/components/AppDragAndDrop/AppDnD'
import CustomAntButton from 'general/components/Button/CustomAntButton'
import ContentContainer from 'general/components/ContentContainer'
import CustomDataTable from 'general/components/CustomDataTable'
import FilterPopover from 'general/components/CustomPopover/FilterPopover'
import PreferenceKeys from 'general/constants/PreferenceKeys'
import ToastHelper from 'general/helpers/ToastHelper'
import Utils, { getYearsFromDates, padNumber } from 'general/utils/Utils'
import useGetSerials from 'hooks/Queries/useGetSerials'
import useAppDnD from 'hooks/useAppDnD'
import useFilter from 'hooks/useFilter'
import { useAppDispatch, useAppSelector } from 'hooks/useRedux'
import useRouter from 'hooks/useRouter'
import useSearchDebounce from 'hooks/useSearchDebounce'
import _ from 'lodash'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { shallowEqual } from 'react-redux'
import { useQueryListHistoryInvoiceTax } from '../../../Invoice/screens/ListInvoice/queries'
import './style.scss'
import { useQuery } from '@tanstack/react-query'
import { goodsQueries } from 'features/Category/screens/GoodsScreen/queries'
import ModalSelectReplaceInvoiceMethod from 'general/components/Modal/ModalSelectReplaceInvoiceMethod'
import InvoiceDashboard from 'features/Invoice/screens/ListInvoice/Components/InvoiceDashboard'
import VIElements from '../ListInInvoice/Components/VIElements'
import KTTooltip from 'general/components/eInvoiceComponents/KTTooltip'
import AppResource from 'general/constants/AppResource'
import VITableRowDropDown from './Components/VITableRowDropDown'
import VIButton from 'general/components/eInvoiceComponents/VIButton'
import VIModal from './Components/VIModal'
import ViewAxionListAccount from './Components/ViewAxionListAccount'
import { thunkJobtitle } from 'features/JobTitle/jobTitleSlice'
import {
  thunkDisconnectCQT,
  thunkGetProfile,
} from 'features/InPutEInvoice/inputEinvoiceSlice'
import AddAccount from './Components/AddAccount'
import ModalContentAxionDisconnect from './Components/ModalContentAxionDisconnect'
import ConnectAccount from './Components/ConnectAccount'

function ConnectTax() {
  // MARK --- Parmas: ---
  const { t } = useTranslation()
  const { navigate } = useRouter()
  const dispatch = useAppDispatch()
  const { listFunctions, userFunctions } = useAppSelector(
    (state) => state?.function,
    shallowEqual,
  )

  const { activeSigningMethod } = useAppSelector(
    (state) => state.system.company,
  )

  const { company } = useAppSelector((state) => state?.system)
  const { selectedInvoices, toggledClearRows, modalStates } = useAppSelector(
    (state) => state.invoice,
    shallowEqual,
  )
  const [modalListAccountShowing, setModalListAccountShowing] = useState(false)
  const [modalAddAccountShowing, setModalAddAccountShowing] = useState(false)
  const [modalDisconnectShowing, setModalDisconnectShowing] = useState(false)
  const [modalConnectAccountShowing, setModalConnectAccountShowing] =
    useState(false)

  const [filterParams, setFilterParams] = useFilter('gFiltersInputInvoice')

  const [profile, setProfile] = useState()
  const { debouncedSearch, search, setSearch } = useSearchDebounce('')
  const [goodsFilterParams] = useState({
    status: 'ACTIVE',
    page: 0,
    limit: 50,
  })
  //#region --- Queries, Mutate ---

  const {
    invoiceListData,
    isGettingListData,
    isRefetching,
    refetchListInvoice,
  } = useQueryListHistoryInvoiceTax(debouncedSearch, {
    ...filterParams,
    optimize: 1,
  })

  const { data: goodsOption } = useQuery({
    ...goodsQueries.listOfGoods(goodsFilterParams),
    select: (res) => {
      return _.concat(
        { value: null, label: 'Tất cả hàng hóa' },
        res?.goods,
      ).map((v) => ({
        label: v.label ?? v.name,
        value: v.name ?? v.value,
      }))
    },
  })

  const getProfile = async () => {
    const data = await dispatch(thunkGetProfile())
    // console.log('data', data?.payload?.account)
    setProfile(data?.payload?.account ?? {})
  }

  const disconnect = async (body) => {
    const data = await dispatch(thunkDisconnectCQT(body))
    console.log('data', data?.payload?.account)
  }

  useEffect(() => {
    getProfile()
  }, [])

  const defaultValues = useMemo(() => {
    /** @type {Array<FilterDefaultValueProp>} */
    const arr = []
    return arr
  }, [goodsOption])

  const defaultColumns = useMemo(
    () => [
      {
        name: t('TakeInvoiceDate'),
        minWidth: '180px',
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className="font-weight-normal m-0 text-maxline-3"
            >
              {row?.syncDate
                ? Utils.formatDateTime(row?.syncDate, 'DD/MM/YYYY')
                : ''}
            </p>
          )
        },
      },
      {
        name: t('DownloadSucceed'),
        minWidth: '160px',
        right: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className="font-weight-normal m-0 text-maxline-3"
            >
              {Utils.formatNumber(row?.succeededDownload ?? 0)}
            </p>
          )
        },
      },
      {
        name: t('DownloadFailed'),
        minWidth: '120px',
        right: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className="font-weight-normal m-0 text-maxline-3"
            >
              {Utils.formatNumber(row?.failedDownload ?? 0)}
            </p>
          )
        },
      },
      {
        name: t('InvoiceProcessed'),
        minWidth: '120px',
        right: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className="font-weight-normal m-0 text-maxline-3"
            >
              {Utils.formatNumber(row?.processed ?? 0)}
            </p>
          )
        },
      },
      {
        name: t('DuplicatedInvoice'),
        minWidth: '160px',
        right: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className="font-weight-normal m-0 text-maxline-3"
            >
              {Utils.formatNumber(row?.duplicated ?? 0)}
            </p>
          )
        },
      },
      {
        name: t('InvoiceProcessing'),
        minWidth: '200px',
        right: true,
        style: {},
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className="font-weight-normal m-0 text-maxline-3"
            >
              {Utils.formatNumber(row?.processing ?? 0)}
            </p>
          )
        },
      },
      {
        name: t('InvoiceSkipped'),
        minWidth: '160px',
        right: true,
        style: {
          borderRight: 'none',
        },
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className="font-weight-normal m-0 text-maxline-3"
            >
              {Utils.formatNumber(row?.malformed ?? 0)}
            </p>
          )
        },
      },
      // {
      //   name: 'Hành động',
      //   center: true,
      //   width: '100px',
      //   style: {
      //     position: 'sticky',
      //     right: 0,
      //     backgroundColor: '#fff',
      //     borderLeft: '1px solid #ebedfe',
      //   },
      //   cell: (row) => (
      //     <div className="d-flex align-items-center justify-content-between">
      //       <VITableRowDropDown
      //         toggleElement={
      //           <div>
      //             <i className="text-grey fas fa-ellipsis-h p-0"></i>
      //           </div>
      //         }
      //         menuItem={[
      //           {
      //             iconElement: <i className="fa-regular fa-circle-info"></i>,
      //             text: t('Detail'),
      //             click: () => {
      //               // setSelectedHistory(row)
      //               // setModalConnectionAxionHistoryDetailShowing(true)
      //             },
      //           },
      //           {
      //             iconElement: <i className="fa-regular fa-rotate-right"></i>,
      //             text: t('ReDownload'),
      //             click: () => {
      //               // handleReloadConnectionHistory(row)
      //             },
      //           },
      //         ]}
      //       />
      //     </div>
      //   ),
      // },
    ],
    [dispatch, t],
  )

  const dynamicColumns = useAppDnD(defaultColumns)

  useEffect(() => {
    refetchListInvoice()
  }, [refetchListInvoice])

  useEffect(() => {
    setFilterParams({
      q: debouncedSearch,
      page: 1,
    })
  }, [debouncedSearch, setFilterParams])

  return (
    <>
      {profile && (
        <ContentContainer
          wrapperClassName="list-invoice"
          tabs={<InvoiceDashboard statistics={invoiceListData?.statistics} />}
        >
          {(profile?.Organization?.isInput ??
          profile?.OrganizationDepartment?.isInput) ? (
            <>
              <ContentContainer.Header
                titleContent={'Lịch sử nhận hóa đơn'}
                toolBar={
                  <Space>
                    <VIButton
                      // beforeIcon={<i className="fa-regular fa-add" />}
                      text={t('ListAccount')}
                      className="btn-white p-3"
                      onClick={() => {
                        setModalListAccountShowing(true)
                      }}
                    />
                    <VIButton
                      // beforeIcon={<i className="fa-regular fa-add" />}
                      text={t('addUser')}
                      className="btn-white p-3"
                      onClick={() => {
                        setModalAddAccountShowing(true)
                      }}
                    />
                    <div className="d-flex gap-2">
                      <VIButton
                        beforeIcon={<i className="fa-regular fa-rotate-left" />}
                        text={t('ReConnect')}
                        className="btn-green border-0 p-3"
                        onClick={() => {
                          // setInitialAxionUsername(axionUserName)
                          // setInitialAxionPassword(axionPassword)
                          setModalConnectAccountShowing(true)
                        }}
                      />
                      <VIButton
                        beforeIcon={
                          <i className="fa-regular fa-link-simple-slash" />
                        }
                        text={t('Disconnect')}
                        className="btn-red border-0 p-3"
                        onClick={() => {
                          console.log('profile', profile)
                          setModalDisconnectShowing(true)
                        }}
                      />
                    </div>
                    <AppDnD
                      defaultColumns={defaultColumns}
                      localStorageName={PreferenceKeys.savedColumnsInputInvoice}
                    />
                  </Space>
                }
              >
                <Space
                  wrap
                  // className={Utils.cn(
                  //   selectedInvoices.length > 0 ? 'd-none' : '',
                  // )}
                >
                  {' '}
                  {/* <CustomAntInput
            type="search"
            borderRadius="sm"
            width={150}
            inputProps={{
              value: search,
              onChange: (e) => setSearch(e.target.value),
            }}
          /> */}
                  <FilterPopover
                    menuPosition="bottomLeft"
                    defaultValues={defaultValues}
                    savedKey={'gFiltersInvoiceList'}
                    onApply={setFilterParams}
                    // onchangeDate={onchangeDate}
                    notViewAll={1}
                  />
                </Space>
              </ContentContainer.Header>
              <ContentContainer.Body>
                <CustomDataTable
                  columns={dynamicColumns}
                  dataSource={invoiceListData?.tableData}
                  isLoading={isGettingListData || isRefetching}
                  isClickable
                  handleDoubleClickRow={(row) => {
                    // viewPdfInvoice(row)
                  }}
                  pagination={{
                    total: invoiceListData?.total,
                    rowsPerPage: filterParams.limit,
                    currentPage: filterParams.page,
                    onChangePage: (page) => {
                      setFilterParams({
                        page,
                      })
                    },
                    onChangeRowsPerPage: (limit) => {
                      setFilterParams({
                        limit,
                        page: 1,
                      })
                    },
                  }}
                  // isSelectable
                  selectedRows={{
                    clearSelectedRows: toggledClearRows,
                    handleSelectedRows: ({ selectedRows }) =>
                      dispatch(setSelectedInvoices(selectedRows)),
                    selectableRowSelected: (row) =>
                      _.includes(selectedInvoices, row),
                  }}
                />
              </ContentContainer.Body>
            </>
          ) : (
            <>
              <ContentContainer.Header
                titleContent={'Kết nối cơ quan thuế'}
                toolBar={
                  <Space>
                    <VIButton
                      // beforeIcon={<i className="fa-regular fa-add" />}
                      text={t('ListAccount')}
                      className="btn-white p-3"
                      onClick={() => {
                        setModalListAccountShowing(true)
                      }}
                    />
                    <VIButton
                      // beforeIcon={<i className="fa-regular fa-add" />}
                      text={t('addUser')}
                      className="btn-white p-3"
                      onClick={() => {
                        setModalAddAccountShowing(true)
                      }}
                    />
                  </Space>
                }
              ></ContentContainer.Header>
              <ContentContainer.Body>
                <div className="mt-4">
                  <div className="row">
                    <div className="col">
                      <div
                        className="overflow-hidden bg-white p-6"
                        style={{
                          borderRadius: '14px',
                          boxShadow: '0px 8px 24px 0px rgba(37, 42, 91, 0.05)',
                        }}
                      >
                        <img
                          className="mb-4 h-250px"
                          src={AppResource.images.imgAxionBg}
                        />
                        <p className="font-size-lg font-weight-bold">
                          Hệ thống tra cứu hoá đơn điện tử theo Nghị định
                          123/2020/NĐ-CP
                        </p>
                        <VIButton
                          className="btn-blue border-0 mt-2 p-2"
                          text={t('Connect')}
                          onClick={() => {
                            setModalConnectAccountShowing(true)
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </ContentContainer.Body>
            </>
          )}

          {/* modal list account */}
          <VIModal
            titleModal={t('ListAccount')}
            modalSize="xl"
            show={modalListAccountShowing}
            contentModal={
              <ViewAxionListAccount profile={profile} getProfile={getProfile} />
            }
            closeBtn
            handleSubmit={() => {
              //   setInitialAxionUsername('')
              //   setInitialAxionPassword('')
              //   setInInvoiceOn(true)
              //   setOutInvoiceOn(false)
              //   setAddMoreAccountMode(true)
              //   setModalListAccountShowing(false)
              //   handleConnectAxion()
            }}
            onHide={() => {
              setModalListAccountShowing(false)
            }}
            // buttonPositive={t('AddAccount')}
            buttonNegative={t('Close')}
          />
          {/* modal add account */}
          <VIModal
            titleModal={t('addUser')}
            modalSize="xl"
            show={modalAddAccountShowing}
            contentModal={
              <AddAccount
                profile={profile}
                setModalAddAccountShowing={setModalAddAccountShowing}
                refetctProfile={getProfile}
              />
            }
            closeBtn
            handleSubmit={() => {
              //   setInitialAxionUsername('')
              //   setInitialAxionPassword('')
              //   setInInvoiceOn(true)
              //   setOutInvoiceOn(false)
              //   setAddMoreAccountMode(true)
              //   setModalListAccountShowing(false)
              //   handleConnectAxion()
            }}
            onHide={() => {
              setModalAddAccountShowing(false)
            }}
            // buttonPositive={t('AddAccount')}
            // buttonNegative={t('Close')}
          />

          {/* modal disconnect */}
          <VIModal
            titleModal={t('Disconnect')}
            show={modalDisconnectShowing}
            contentModal={
              <ModalContentAxionDisconnect
                profile={profile}
                onPressCancel={() => {
                  setModalDisconnectShowing(false)
                }}
                onPressDisconnect={async ({ isInput, isOutput }) => {
                  // const res = await AxionHelper.callApiDisconnect(isInput, isOutput)
                  // if (res) {
                  //   setModalDisconnectShowing(false)
                  //   // dispatch(thunkGetProfile())
                  //   ToastHelper.showSuccess(t('DisconnectAxionSuccess'))
                  // }
                  await disconnect({ isInput, isOutput })
                  setModalDisconnectShowing(false)
                  // dispatch(thunkGetProfile())
                  ToastHelper.showSuccess(t('DisconnectAxionSuccess'))
                  await getProfile()
                }}
              />
            }
            closeBtn
            handleSubmit={(values) => {
              console.lg('values', values)
            }}
            onHide={() => {
              setModalDisconnectShowing(false)
            }}
          />

          {/* modal connect account */}
          <VIModal
            titleModal={t('SetupConnection')}
            modalSize="xl"
            show={modalConnectAccountShowing}
            contentModal={
              <ConnectAccount
                profile={profile}
                setModalAddAccountShowing={setModalConnectAccountShowing}
                refetctProfile={getProfile}
              />
            }
            closeBtn
            handleSubmit={() => {
              //   setInitialAxionUsername('')
              //   setInitialAxionPassword('')
              //   setInInvoiceOn(true)
              //   setOutInvoiceOn(false)
              //   setAddMoreAccountMode(true)
              //   setModalListAccountShowing(false)
              //   handleConnectAxion()
            }}
            onHide={() => {
              setModalConnectAccountShowing(false)
            }}
            // buttonPositive={t('AddAccount')}
            // buttonNegative={t('Close')}
          />
        </ContentContainer>
      )}
    </>
  )
}

export default ConnectTax
